import { Component, OnInit } from '@angular/core';
import {Constants} from '../../util/Constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public vendorTitle : string = Constants.VENDOR;
  public version : string = Constants.VERSION;

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/footer/footer.component.ts